import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import NoticeTypeMstSelectButton from '@/components/Ui/NoticeTypeMstSelectButton'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'DeliveryTypeMst',
  components: {
    Loading,
    NoticeTypeMstSelectButton
  },
  metaInfo () {
    let title = this.categoryName + 'マスタ | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'deliveryTypeMstId',
        'deliveryTypeName',
        'deliveryType',
        'deliveryPriorityKbn',
        'cmsDisplayKbn',
        'ledDisplayKbn',
        'deliveryConfigFlg',
        'linkedNoticeTypes',
        'deliveryTypeStatus',
        'modifyButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          deliveryTypeMstId: '配信タイプID',
          deliveryTypeName: '配信タイプ名',
          deliveryType: '配信タイプ',
          deliveryPriorityKbn: '優先度',
          cmsDisplayKbn: 'CMS表示',
          ledDisplayKbn: 'LED設定',
          deliveryTypeStatus: 'ステータス',
          deliveryConfigFlg: '配信設定対応',
          linkedNoticeTypes: 'お知らせタイプ設定',
          modifyButton: ''
        },
        columnsClasses: {
          deliveryTypeMstId: 'wp-5',
          deliveryTypeName: '',
          deliveryType: '',
          deliveryPriorityKbn: '',
          cmsDisplayKbn: '',
          ledDisplayKbn: '',
          deliveryTypeStatus: '',
          deliveryConfigFlg: '',
          linkedNoticeTypes: '',
          modifyButton: 'wp-5 has-button'
        },
        sortable: [
          'deliveryTypeMstId',
          'deliveryTypeName',
          'deliveryType',
          'deliveryPriorityKbn',
          'cmsDisplayKbn',
          'ledDisplayKbn',
          'deliveryConfigFlg',
          'deliveryTypeStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      modifyTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.deliveryTypeMst.categoryName,

      // model
      deliveryTypeMstModel: state => state.deliveryTypeMst.deliveryTypeMstModel,
      // 202305 配信先設定 追加 ST
      deviceModel: state => state.deliveryTypeMst.deviceModel,
      // 202305 配信先設定 追加 ED

      // form
      values: state => state.deliveryTypeMst.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'deliveryTypeMst/isRegister',
      isModify: 'deliveryTypeMst/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.deliveryTypeMstModel, 'deliveryTypeMstUuid', this.modifyTargetId, 'deliveryTypeMstId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    priorityList () {
      return Constants.Mst.DeliveryPriorityKbn
    },
    cmsSettingList () {
      return Constants.Mst.CmsDisplayKbn
    },
    ledSettingList () {
      return Constants.Mst.LedDisplayKbn.sort(Utility.sortByKey('index', false))
    },
    deliveryConfigList () {
      return Constants.Mst.DeliveryConfig.sort(Utility.sortByKey('index', true))
    },
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
    // 202305 配信先設定 追加 ST
    deviceList() {
      return this.deviceModel.map(item => {
        return {
          value: item.deviceTypeUuid,
          label: item.modelNumber
        }
      })
    },
    // 202305 配信先設定 追加 ED

    // input
    inpDeliveryTypeName: {
      get () {
        return this.values.inpDeliveryTypeName
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryTypeName',
          value: value
        })
      }
    },
    inpDeliveryType: {
      get () {
        return this.values.inpDeliveryType
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryType',
          value: value
        })
      }
    },
    inpDeliveryPriorityKbn: {
      get () {
        return this.values.inpDeliveryPriorityKbn
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryPriorityKbn',
          value: value
        })
      }
    },
    inpCmsDisplayKbn: {
      get () {
        return this.values.inpCmsDisplayKbn
      },
      set (value) {
        this.setInputValue({
          key: 'inpCmsDisplayKbn',
          value: value
        })
      }
    },
    inpLedDisplayKbn: {
      get () {
        return this.values.inpLedDisplayKbn
      },
      set (value) {
        this.setInputValue({
          key: 'inpLedDisplayKbn',
          value: value
        })
      }
    },
    inpLedInterval: {
      get () {
        return this.values.inpLedInterval
      },
      set (value) {
        this.setInputValue({
          key: 'inpLedInterval',
          value: value
        })
      }
    },
    inpDeliveryConfig: {
      get () {
        return this.values.inpDeliveryConfig
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryConfig',
          value: value
        })
      }
    },
    // 202305 配信先設定 追加 ST
    inpTargetDeviceTypeUuids: {
      get() {
        return this.values.inpTargetDeviceTypeUuids
      },
      set(value) {
        this.setInputValue({
          key: 'inpTargetDeviceTypeUuids',
          value: value
        })
      }
    },
    inpIsFavoritesVisibleOnSPApp: {
      get() {
        return this.values.inpIsFavoritesVisibleOnSPApp
      },
      set(value) {
        this.setInputValue({
          key: 'inpIsFavoritesVisibleOnSPApp',
          value: value
        })
      }
    },
    // 202305 配信先設定 追加 ED
    inpNoticeTypes: {
      get () {
        return this.values.inpNoticeTypes
      },
      set (value) {
        this.setInputValue({
          key: 'inpNoticeTypes',
          value: value
        })
      }
    },
    inpStatus: {
      get () {
        return this.values.inpStatus
      },
      set (value) {
        this.setInputValue({
          key: 'inpStatus',
          value: value
        })
      }
    },

    // disabled
    disableLedInterval () {
      return this.inpLedDisplayKbn !== 2
    },

    // validate
    inpDeliveryTypeNameIsValid () {
      return Validator.validText(this.inpDeliveryTypeName)
    },
    inpDeliveryTypeIsValid () {
      return Validator.validText(this.inpDeliveryType)
    },
    inpDeliveryPriorityKbnIsValid () {
      return Validator.validSelect(this.inpDeliveryPriorityKbn)
    },
    inpCmsDisplayKbnIsValid () {
      return Validator.validSelect(this.inpCmsDisplayKbn)
    },
    inpLedDisplayKbnIsValid () {
      if (!Validator.validId(this.inpLedDisplayKbn)) return false
      return this.inpLedDisplayKbn === 2 ?
        Validator.validText(this.inpLedInterval) :
        true
    },
    inpDeliveryConfigIsValid () {
      return Validator.validSelect(this.inpDeliveryConfig)
    },
    // 202305 配信先設定 追加 ST
    inpStatusIsValid() {
      return Validator.validSelect(this.inpStatus)
    },
    inpTargetDeviceTypeUuidsIsValid() {
      return Validator.validArray(this.inpTargetDeviceTypeUuids) || this.inpIsFavoritesVisibleOnSPApp
    },
    formIsValid () {
      return this.inpDeliveryTypeNameIsValid &&
        this.inpDeliveryTypeIsValid &&
        this.inpDeliveryPriorityKbnIsValid &&
        this.inpCmsDisplayKbnIsValid &&
        this.inpLedDisplayKbnIsValid &&
        this.inpDeliveryConfigIsValid &&
        this.inpStatusIsValid &&
        this.inpTargetDeviceTypeUuidsIsValid
    },
    // 202305 配信先設定 追加 ED
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'deliveryTypeMst/loadModel',
      initRegister: 'deliveryTypeMst/initRegister',
      initModify: 'deliveryTypeMst/initModify',
    }),
    ...mapMutations({
      setInputValue: 'deliveryTypeMst/setInputValue',
    }),

    init () {
      this.loading = true

      //TODO
      let deliveryTypeMstParams = {}

      // データ読出し
      this.loadModel({
        deliveryTypeMstParams: deliveryTypeMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.deliveryTypeMstModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    changeLedSetting () {
      if (this.inpLedDisplayKbn !== 2) {
        this.inpLedInterval = ''
      }
    },

    /**
     * お知らせタイプの変更
     */
    changeNoticeTypeValue (props) {
      console.log(props)
      this.inpNoticeTypes = props.data
      // this.$set(this.input.btnSetting.badgeDisplayParameter, 'serviceRssUUIDs', props.data)
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.deliveryTypeMstModel, 'deliveryTypeMstUuid', this.modifyTargetId, 'deliveryTypeMstId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true
      // console.log(this.isModify)
      // パラメータを生成
      let parameters = {
        request: {
          deliveryTypeName: this.inpDeliveryTypeName,
          deliveryType: this.inpDeliveryType,
          deliveryPriorityKbn: this.inpDeliveryPriorityKbn,
          cmsDisplayKbn: this.inpCmsDisplayKbn,
          ledDisplayKbn: this.inpLedDisplayKbn,
          deliveryConfigFlg: this.inpDeliveryConfig,
          // 202305 配信先設定 追加 ST
          targetDeviceTypeUuids: this.inpTargetDeviceTypeUuids,
          isTargetSpApp: this.inpIsFavoritesVisibleOnSPApp,
          // 202305 配信先設定 追加 ED
          deliveryTypeStatus: this.inpStatus
        }
      }
      if (this.inpLedDisplayKbn === 2) {
        parameters.request.ledOnInterval = this.inpLedInterval
      }
      if (this.inpNoticeTypes.length) {
        parameters.request.linkedNoticeTypeMstUuids = this.inpNoticeTypes
      }
      if (this.isModify) {
        parameters.deliveryTypeMstUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['deliveryTypeMst'],
        [this.isRegister ?
          'v1DeliveryTypeMstPost' :
          'v1DeliveryTypeMstPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null

            // 一覧データを再読出し
            this.init()
            this.registerItem()
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }

        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'deliveryPriorityKbn':
          return Utility.getConstantsLabel(['Mst', 'DeliveryPriorityKbn'], value)
        case 'cmsDisplayKbn':
          return Utility.getConstantsLabel(['Mst', 'CmsDisplayKbn'], value)
        case 'ledDisplayKbn':
          return value === 2 ?
            Utility.getConstantsLabel(['Mst', 'LedDisplayKbn'], value).split('@@').join(props.row.ledOnInterval) :
            Utility.getConstantsLabel(['Mst', 'LedDisplayKbn'], value)
        case 'deliveryConfigFlg':
          return Utility.getConstantsLabel(['Mst', 'DeliveryConfig'], value)
        case 'linkedNoticeTypes':
          return value.map(item => item.noticeTypeName).join('、')
        case 'deliveryTypeStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      this.modifyTargetId = null
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.deliveryTypeMstUuid
      this.initModify({
        data: props.row
      })
    },
  }
}